import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { moveToProcessPO } from './actions';
import { showSuccessNotification, showErrorNotification } from 'src/util/notifications';
import { REDUCER_KEY } from './reducer';

const MoveToFtpFolder: React.FC = () => {
  const [searchParams] = useSearchParams();
  const fileName = searchParams.get("fileName");
  const vendor = searchParams.get("vendor");
  const dispatch = useDispatch();
  const ftpFileTransfer = useSelector((state: any) => state[REDUCER_KEY]);
  const [loading, setLoading] = useState(false);
  const [moved, setMoved] = useState(false);

  useEffect(() => {
    if (loading) {
      if (ftpFileTransfer && ftpFileTransfer.error) {
        setLoading(false);
        showErrorNotification(ftpFileTransfer.error);
      } else if (!ftpFileTransfer.loading && ftpFileTransfer.data) {
        setLoading(false);
        setMoved(true);
        if(ftpFileTransfer.data.includes("not found"))
          showErrorNotification("File not found.");
        else
          showSuccessNotification('File moved successfully!');
      }
    }
  }, [ftpFileTransfer, loading]);

  const handleMoveFile = () => {
    setLoading(true);
    dispatch(moveToProcessPO({ VendorName: vendor, FileName: fileName }));
  };

  return (
    <div style={{ padding: 24 }}>
      <h4>Move a file to other folder</h4>
      <p>File Name: {fileName}</p>
      <p>Vendor: {vendor}</p>
      <Button type="primary" onClick={handleMoveFile} loading={loading} disabled={moved}>
        Move To ProcessPO
      </Button>
    </div>
  );
};

export default MoveToFtpFolder;
